import api from "./api";

// Capa de servicios API del dominio "monitoring" (DBA / servicios backend) (FSD / capa API transversal).
export const getMonitoringStatus = () => api.get("/monitoring/status");
export const toggleMonitoringService = (payload) =>
  api.post("/monitoring/toggle-service", payload);
export const cleanupMonitoring = () => api.post("/monitoring/cleanup");
